import { Endpoint } from "shared/utils/endpoints";
import { HTTP_CLIENT } from "shared/utils/interceptor";

const CreateBlogService = (
  category: string,
  title: string,
  cover: File,
  content: string
) => {
  const formData = new FormData();
  formData.append("category", category);
  formData.append("title", title);
  formData.append("cover", cover);
  formData.append("content", content);

  return HTTP_CLIENT.post(`${Endpoint.blogs.createBlog}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const UpdateBlogService = (
  category: string,
  title: string,
  cover: File | null,
  content: string,
  id: number
) => {
  const formData = new FormData();
  formData.append("category", category);
  formData.append("title", title);
  if (cover) {
    formData.append("cover", cover);
  }
  formData.append("content", content);

  return HTTP_CLIENT.patch(`${Endpoint.blogs.updateBlog}/${id}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
};

const DeleteBlogService = (id: number) => {
  return HTTP_CLIENT.delete(`${Endpoint.blogs.deleteBlog}/${id}`);
};

const GetAllBlogsService = (page: number, limit: number = 10) => {
  return HTTP_CLIENT.get(`${Endpoint.blogs.getAllBlogs}`, {
    params: {
      page,
      limit,
    },
  });
};

export {
  CreateBlogService,
  DeleteBlogService,
  GetAllBlogsService,
  UpdateBlogService,
};
